import { PlusCircleIcon } from './PlusCircleIcon';

/**
 * author: Google
 * id 0F76DADF-2A8D-4C1F-B43E-DC3C6D282BBF
 * name plus-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus-circle.svg
 * tags
 */
export const AddCircleIcon = PlusCircleIcon;
export default AddCircleIcon